// import external dependencies
import 'jquery'

// import everything from autoload
import './autoload/_bootstrap.js'; import './autoload/_emptySpace.js' // eslint-disable-line

// import vc-elements javascript files
import '../vc_elements/_new/main.js'; import '../vc_elements/accordion_container/main.js'; import '../vc_elements/accordion_item/main.js'; import '../vc_elements/button/main.js'; import '../vc_elements/calculator_roi/main.js'; import '../vc_elements/contact_box/main.js'; import '../vc_elements/counting_numbers/main.js'; import '../vc_elements/divider_text/main.js'; import '../vc_elements/faq_list/main.js'; import '../vc_elements/get_a_sample/main.js'; import '../vc_elements/gif_module/main.js'; import '../vc_elements/googlemap/main.js'; import '../vc_elements/header_indicators/main.js'; import '../vc_elements/header/main.js'; import '../vc_elements/headline_background/main.js'; import '../vc_elements/hero/main.js'; import '../vc_elements/info_table/main.js'; import '../vc_elements/infobox_gif/main.js'; import '../vc_elements/large_checkmark_list/main.js'; import '../vc_elements/large_product_teaser/main.js'; import '../vc_elements/link_list/main.js'; import '../vc_elements/material_info_us/main.js'; import '../vc_elements/material_info/main.js'; import '../vc_elements/partner_list/main.js'; import '../vc_elements/platform/main.js'; import '../vc_elements/price_box/main.js'; import '../vc_elements/product_teaser/main.js'; import '../vc_elements/table_list/main.js'; import '../vc_elements/teaser_indicators/main.js'; import '../vc_elements/template_element/main.js'; import '../vc_elements/testimonials/main.js'; import '../vc_elements/text_icon_box/main.js'; import '../vc_elements/tile_list/main.js'; import '../vc_elements/typewriting_text/main.js'; import '../vc_elements/video_box/main.js' // eslint-disable-line

// import react habitat and react components
import './init/react'

// import local dependencies
import Router from './util/Router'
import common from './routes/common'
import home from './routes/home'
import aboutUs from './routes/about'

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
})

// Load Events
jQuery(document).ready(() => routes.loadEvents())
